// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Enviar',
    stop: 'Detener',
    attach: 'Adjuntar archivos',
    add: 'Añadir',
    upload_files: 'Subir archivos',
  },
  attachment: {
    uploading: 'Subiendo {{percent}}%',
    uploading_file: 'Subiendo {{name}}',
    retry: 'Reintentar',
    remove: 'Quitar {{name}}',
    cancel: 'Cancelar la subida de {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'En espera',
    running: 'En ejecución',
    done: 'Hecho',
    failed: 'Error',
    denied: 'Rechazado',
    background: 'En segundo plano',
    summary_one: '{{count}} paso',
    summary_other: '{{count}} pasos',
    failed_count_one: '{{count}} con error',
    failed_count_other: '{{count}} con error',
    retried_one: '{{count}} falló y se reintentó',
    retried_other: '{{count}} fallaron y se reintentaron',
  },
  question: {
    suggested: 'Sugerido',
    withdrawn: 'Ya no es necesario',
  },
  thread: {
    live_on: 'En vivo en {{domain}}',
    unread_one: '{{count}} nuevos',
    unread_other: '{{count}} nuevos',
    working: 'En ello',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Hecho',
    running: 'En curso',
    waiting: 'Requiere atención',
    failed: 'Error',
    pending: 'Aún no',
    skipped: 'Omitido',
  },
  lightbox: {
    enlarge: 'Ampliar: {{label}}',
    close: 'Cerrar',
  },
};
